import type { LogoProps } from '../../logo.types'
import { logos } from './logos'

type LogoRDSaudeTaglineProps = LogoProps

export const LogoRDSaudeTagline = (props: LogoRDSaudeTaglineProps) => {
  const { size, type } = props

  const SvgComponent = logos[type][size]

  return SvgComponent
}
